var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1128 5.89062H5.89062V18.1128H18.1128V5.89062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 10.2839L13.4936 11.0839L14.3736 10.4439V15.0839H15.3336V9.00391H14.5336L12.9336 10.2839Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.411 11.8532C11.7583 11.5343 11.9738 11.0921 11.9738 10.6038C11.9738 9.6332 11.1222 8.84375 10.0755 8.84375C9.18549 8.84375 8.42437 9.40431 8.22549 10.2065L9.14604 10.4404C9.23771 10.0715 9.62826 9.80375 10.0755 9.80375C10.5988 9.80375 11.0249 10.1626 11.0249 10.6038C11.0249 11.0449 10.5988 11.4038 10.0755 11.4038H9.5216V12.3638H10.0755C10.676 12.3638 11.1827 12.781 11.1827 13.2749C11.1827 13.7771 10.7016 14.186 10.1099 14.186C9.57549 14.186 9.11882 13.8471 9.0466 13.3982L8.10938 13.5515C8.25493 14.4604 9.11493 15.146 10.1094 15.146C11.2244 15.146 12.1316 14.3065 12.1316 13.2749C12.1316 12.7065 11.8516 12.1965 11.411 11.8532Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5573 21.9991H6.44618L5.89062 19.7769L6.44618 17.5547H17.5573L18.1128 19.7769L17.5573 21.9991Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7769 18.1128L21.9991 17.5573V6.44618L19.7769 5.89062L17.5547 6.44618V17.5573L19.7769 18.1128Z",
    fill: "#4CAF50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 6.44444L18.1111 4.22222L17.5556 2H3.66667C2.74611 2 2 2.74611 2 3.66667V17.5556L4.22222 18.1111L6.44444 17.5556V6.44444H17.5556Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5547 17.5547V21.9991L21.9991 17.5547H17.5547Z",
    fill: "#E53935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3325 2H17.5547V6.44444H21.9991V3.66667C21.9991 2.74611 21.253 2 20.3325 2Z",
    fill: "#1565C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 21.9991H6.44444V17.5547H2V20.3325C2 21.253 2.74611 21.9991 3.66667 21.9991Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.03278b7f.svg";
export { ForwardRef as ReactComponent };